import slug from 'slug'
import Cookies from 'cookies-js'

export default {
  state: {
    dictionary: {
      data: [],
      search: '',
      page: 1,
      totalPages: 1,
      sort: {
        name: 1
      }
    },
    selectedLanguage: 'RO',
    languageSet: false
  },
  getters: {
    getAllDictionarys: state => state.dictionary,
    getDictionarysPage: state => state.dictionary.page,
    getDictionarySearch: state => state.dictionary.search,
    getDictionarysData: state => {
      if (state.dictionary.data && state.dictionary.data.data && state.dictionary.data.data.length) {
        return state.dictionary.data.data[0]
      } else {
        return null
      }
    },
    translate (state) {
      return (sheet, item) => {
        if (!item) return ''
        if (state.dictionary.data && state.dictionary.data.data && state.dictionary.data.data.length) {
          let dict = state.dictionary.data.data[0]
          let lang = state.selectedLanguage
          switch (sheet) {
            case 'interfata': {
              return dict[sheet][item] ? dict.interfata[item][lang] : item
            }
            case 'texte':
            case 'popups':
            case 'date': {
              if (lang === 'RO') return item
              let s = slug(item)
              return dict[sheet][s] ? dict[sheet][s][lang] : item
            }
          }
        }
        return item
      }
    },
    languages: state => {
      // return state.dictionary.data
      if (state.dictionary.data.data && state.dictionary.data.data.length) {
        return state.dictionary.data.data[0].langs
      }
      return null
    },
    selectedLanguage: state => state.selectedLanguage,
    languageSet: state => state.languageSet
  },
  mutations: {
    setLanguage (state, langOptions) {
      state.selectedLanguage = langOptions.lang
      state.languageSet = langOptions.languageSet
      if (langOptions.languageSet) {
        Cookies.set('bgt-lang', langOptions.lang)
      }
    },
    fillDictionarys (state, data) {
      state.dictionary.data = data
    },
    clearDictionarys (state) {
      state.dictionary.data = []
    },
    setDictionarysPage (state, page) {
      state.dictionary.page = page
    },
    setDictionarysSort (state, sort) {
      state.dictionary.sort = sort
    },
    setDictionarysSearch (state, search) {
      state.dictionary.search = search
    }
  },
  actions: {
    fetchDictionarys ({commit, state, rootState}) {
      commit('setFetching', true)
      let query = {
        $skip: (state.dictionary.page - 1) * 10,
        $sort: state.dictionary.sort
      }
      if (state.dictionary.search.length) {
        query['orRegex'] = [
          {
            name: {
              $search: state.dictionary.search
            }
          }
        ]
      }
      rootState.services.dictionary.find({query}).then(result => {
        commit('fillDictionarys', result)
        commit('setFetching', false)
      })
    },
    saveDictionary ({dispatch, commit, state, rootState}, data) {
      rootState.services.dictionar.create(data)
        .then(res => {
          dispatch('fetchDictionarys')
          commit('setSnack', {
            message: 'Operatiune reusita. Dictionary adaugat.',
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    updateDictionary ({dispatch, commit, state, rootState}, data) {
      rootState.services.dictionary.update(data._id, data)
        .then(res => {
          dispatch('fetchDictionarys')
          commit('setSnack', {
            message: 'Operatiune reusita. Dictionary modificat.',
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    deleteDictionary ({dispatch, commit, state, rootState}, _ids) {
      rootState.services.dictionary.remove(null, {query: {_id: {$in: _ids}}})
        .then(res => {
          dispatch('fetchDictionarys')
          commit('setSnack', {
            message: `Operatiune reusita. ${res.length} dictionary(e) eliminat(e).`,
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          error.meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', error)
        })
    },
    setDictionarysPage ({commit, dispatch}, page) {
      commit('setDictionarysPage', page)
      dispatch('fetchDictionarys')
    },
    setDictionarysSort ({commit, dispatch}, sort) {
      commit('setDictionarysSort', sort)
      dispatch('fetchDictionarys')
    },
    setDictionarySearch ({commit, dispatch}, search) {
      commit('setDictionarySearch', search)
      dispatch('fetchDictionarys')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dictionary.js